import axios from 'axios';
import {API_ROOT, translate} from '../app/utils';
import {msgBar} from './msgBarActions';

export function getApplicationAccess () {
	return function (dispatch) {
		axios.get(API_ROOT + '/api/application-access', {withCredentials: true}).then( response => {
			dispatch({
				type: "GET_APPLICATION_ACCESS",
				payload: response.data
			});
		});
	}
}

export function isAddingNewKey (boolean) {
	return {
		type: "IS_ADDING_NEW_KEY",
		payload: boolean
	}
}

export function postApplicationAccess (applicationName) {
	return function (dispatch) {
		axios.post(API_ROOT + '/api/application-access', {"applicationName": applicationName}, {withCredentials: true}).then( () => {
			dispatch(getApplicationAccess());
			dispatch(isAddingNewKey(false));
			dispatch(msgBar(['success', translate('apiKeySuccessfullyAddedMessage')]))
		}).catch(() => {
			dispatch(isAddingNewKey(false));
			dispatch(msgBar(['error', translate('apiKeyErrorAddedMessage')]));
		});
	}
}

export function deleteApplicationAccess (applicationName) {
	return function (dispatch) {
		axios.delete(API_ROOT + '/api/application-access?name=' + applicationName, {withCredentials: true}).then( () => {
			dispatch(getApplicationAccess());
			dispatch(msgBar(['success', translate('apiKeySuccessfullyDeletedMessage')]))
		}).catch(() => {
			dispatch(msgBar(['error', translate('apiKeyErrorDeletedMessage')]));
		});
	}
}
